export const SEARCHING = 'SEARCHING'
export const SEARCH_SUCCESS = 'SEARCH_SUCCESS'
export const SEARCH_FAILURE = 'SEARCH_FAILURE'
export const SEARCH_EMPTY = 'SEARCH_EMPTY'

export const SEARCH_SET_SELECT = 'SEARCH_SET_SELECT'
export const SEARCH_UNSET_SELECT = 'SEARCH_UNSET_SELECT'

export const SEARCH_ACTIVEVIEW = 'SEARCH_ACTIVEVIEW'

export const SEARCH_EDIT_SELECT = 'SEARCH_EDIT_SELECT'
export const SEARCH_EDIT_UNSET_SELECT = 'SEARCH_EDIT_UNSET_SELECT'
export const SEARCH_EDIT = 'SEARCH_EDIT'
export const SEARCH_EDIT_SUCCESS = 'SEARCH_EDIT_SUCCESS'
export const SEARCH_EDIT_FAILURE = 'SEARCH_EDIT_FAILURE'

export const SEARCH_EXPAND_SELECT = 'SEARCH_EXPAND_SELECT'
export const SEARCH_EXPAND_UNSET_SELECT = 'SEARCH_EXPAND_UNSET_SELECT'

export const SEARCH_SHARE_SELECT = 'SEARCH_SHARE_SELECT'
export const SEARCH_SHARE_UNSET_SELECT = 'SEARCH_SHARE_UNSET_SELECT'

export const SEARCH_DELETE = 'SEARCH_DELETE'
export const SEARCH_DELETE_SUCCESS = 'SEARCH_DELETE_SUCCESS'
export const SEARCH_DELETE_FAILURE = 'SEARCH_DELETE_FAILURE'

export const SEARCH_MOVE = 'SEARCH_MOVE'
export const SEARCH_MOVE_SUCCESS = 'SEARCH_MOVE_SUCCESS'
export const SEARCH_MOVE_FAILURE = 'SEARCH_MOVE_FAILURE'

export const ASSET_SEARCH_CHECK_SELECT = 'ASSET_SEARCH_CHECK_SELECT'
export const ASSET_SEARCH_UNCHECK_SELECT = 'ASSET_SEARCH_UNCHECK_SELECT'

export const MULTIPLE_SEARCH_OPTIONS_ACTIVATE = 'MULTIPLE_SEARCH_OPTIONS_ACTIVATE'
export const MULTIPLE_SEARCH_OPTIONS_DEACTIVATE = 'MULTIPLE_SEARCH_OPTIONS_DEACTIVATE'
export const MULTIPLE_SEARCH_OPTIONS_DONE = 'MULTIPLE_SEARCH_OPTIONS_DONE'

export const GO_TO_PAGE = 'GO_TO_PAGE'
export const IS_SEARCH_ADVANCED = 'IS_SEARCH_ADVANCED'
export const SEARCH_ADVANCED_EMPTY = 'SEARCH_ADVANCED_EMPTY'

export const ASSETS_SEARCH_MULTI_DELETE = 'ASSETS_SEARCH_MULTI_DELETE'
export const ASSETS_SEARCH_MULTI_DELETE_SUCCESS = 'ASSETS_SEARCH_MULTI_DELETE_SUCCESS'
export const ASSETS_SEARCH_MULTI_DELETE_FAILURE = 'ASSETS_SEARCH_MULTI_DELETE_FAILURE'

export const ASSETS_SEARCH_MULTI_MOVE = 'ASSETS_SEARCH_MULTI_MOVE'
export const ASSETS_SEARCH_MULTI_MOVE_SUCCESS = 'ASSETS_SEARCH_MULTI_MOVE_SUCCESS'
export const ASSETS_SEARCH_MULTI_MOVE_FAILURE = 'ASSETS_SEARCH_MULTI_MOVE_FAILURE'

export const CLEAN_DATA_BACK_SEARCH = 'CLEAN_DATA_BACK_SEARCH'
export const SCROLL_SEARCH = 'SCROLL_SEARCH'

export const CANCEL_SEARCH = 'CANCEL_SEARCH'

export const GET_SUGGEST = 'GET_SUGGEST'
export const GET_SUGGEST_SUCCESS = 'GET_SUGGEST_SUCCESS'
export const GET_SUGGEST_FAILURE = 'GET_SUGGEST_FAILURE'
